/* Refreshes only the visual cart heading/milestones. Native cart actions stay in cart.js. */
if (!customElements.get('cstm-cart-overview')) {
  customElements.define('cstm-cart-overview', class extends HTMLElement {
    connectedCallback() {
      if (this.cstmUnsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.cstmUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.cstmRefresh(event));
    }

    disconnectedCallback() {
      this.cstmUnsubscribe?.();
      this.cstmUnsubscribe = null;
      this.cstmRequest?.abort();
    }

    async cstmRefresh(event) {
      this.cstmRequest?.abort();
      const request = new AbortController();
      this.cstmRequest = request;
      try {
        const url = new URL(this.dataset.cstmCartUrl, window.location.origin);
        const footer = this.closest('main')?.querySelector('#main-cart-footer');
        const footerId = event?.source !== 'cart-items' ? footer?.dataset.id : null;
        if (footerId) url.searchParams.set('sections', [this.dataset.cstmSectionId, footerId].join(','));
        else url.searchParams.set('section_id', this.dataset.cstmSectionId);
        const response = await fetch(url, { signal: request.signal, cache: 'no-store' });
        if (!response.ok) return;
        const sections = footerId ? await response.json() : null;
        const markup = sections ? sections[this.dataset.cstmSectionId] : await response.text();
        if (!markup) return;
        const html = new DOMParser().parseFromString(markup, 'text/html');
        const source = html.getElementById(this.id)?.querySelector('[data-cstm-overview-content]');
        const target = this.querySelector('[data-cstm-overview-content]');
        if (!request.signal.aborted && this.isConnected && source && target) {
          target.replaceWith(source);
          if (footerId && sections[footerId]) {
            const footerHtml = new DOMParser().parseFromString(sections[footerId], 'text/html');
            const footerSource = footerHtml.querySelector('#main-cart-footer .js-contents');
            const footerTarget = footer?.querySelector('.js-contents');
            if (footerSource && footerTarget) footerTarget.replaceWith(footerSource);
          }
        }
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('Cart presentation could not refresh.', error);
      }
    }
  });
}
